/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S6_TitleInputs */

const en_guide_what_is_json_s6_title = /** @type {(inputs: Guide_What_Is_Json_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Best Practices`)
};

const ko_guide_what_is_json_s6_title = /** @type {(inputs: Guide_What_Is_Json_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 모범 사례`)
};

const ja_guide_what_is_json_s6_title = /** @type {(inputs: Guide_What_Is_Json_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONのベストプラクティス`)
};

/**
* | output |
* | --- |
* | "JSON Best Practices" |
*
* @param {Guide_What_Is_Json_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s6_title = /** @type {((inputs?: Guide_What_Is_Json_S6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s6_title(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s6_title(inputs)
	return ja_guide_what_is_json_s6_title(inputs)
});